import axios from "axios";
import { BASE_URL } from "../constants/api";

async function Patch(path, token, patchData, paramObj) {
  let url = BASE_URL + path;

  const header = {
    headers: token
      ? {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      : {
          "Content-Type": "application/json",
        },
  };

  if (paramObj) {
    let queryString = "";
    Object.keys(paramObj).forEach((val) => {
      if (paramObj[val]?.length > 0) {
        if (queryString.length > 0) {
          queryString += `&${val}=${paramObj[val]}`;
        } else {
          queryString += `?${val}=${paramObj[val]}`;
        }
      }
    });
    url += queryString;
  }

  const { data } = await axios.patch(url, patchData, header);
  return data;
}

export { Patch };
